import { makeAutoObservable } from 'mobx';

export interface MediaStereoAngle {
  angle: number;
}

export class MediaStereo {
  angles: MediaStereoAngle[] = [];

  constructor(angles: MediaStereoAngle[]) {
    makeAutoObservable(this, {
      angles: false,
    });

    this.angles = angles;
  }

  get isStereoAvailable() {
    return this.angles.some((stereoAngle: MediaStereoAngle) => stereoAngle.angle >= 3 && stereoAngle.angle <= 4);
  }
}
